export default "__VITE_ASSET__Bwn47A1x__"